var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoShare24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_share24x24",
    transform: "translate(-3.04 -3.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M15.1,10.138A2.946,2.946,0,0,0,12.8,11.255l-5-2.527A2.851,2.851,0,0,0,7.9,7.976,2.828,2.828,0,0,0,7.77,7.16l4.983-2.512a2.914,2.914,0,0,0,3.677.788,2.893,2.893,0,1,0-4.276-2.53,2.838,2.838,0,0,0,.113.754L7.261,6.184A2.908,2.908,0,1,0,7.3,9.714l4.981,2.515a2.835,2.835,0,0,0-.135.817,2.95,2.95,0,1,0,2.95-2.908Z",
    transform: "translate(.994 3)",
    fill: "#999"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoShare24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_share24x24.6cd6e1c6fe86ee6c5b8c2051144db30a.svg";